export function textAnimation() {
    let SETTINGS = {
        width: "auto",
        tag: "<span class='line'>",
        keepHtml: true,
        isWords: false,
        isLetters: false,
        wordsJustify: false,
    };
    const $textBlocks = $(".split-text");
    if (!$textBlocks.length) return;
    document.fonts.ready.then(function () {
        $textBlocks.each(function () {
            let setting = { ...SETTINGS };
            if ($(this).hasClass("split-words")) {
                setting.isWords = true;
            }
            if ($(this).hasClass("split-letters")) {
                setting.isLetters = true;
            }
            if ($(this).parent().hasClass("words-justify")) {
                setting.wordsJustify = true;
            }

            setting.selector = $(this);
            new splitText(setting);
        });
    });
}


export class splitText {
    constructor({
        selector,
        width,
        keepHtml,
        tag,
        isWords,
        isLetters,
        wordsJustify
    }) {
        this.block = selector;
        this.width = width;
        this.keepHtml = keepHtml;
        this.tag = tag;
        this.isWords = isWords;
        this.isLetters = isLetters;
        this.wordsJustify = wordsJustify;
        this._content = this.block.contents();
        this._text = this.block.text();
        this._words = null;
        this._lettersCount = 0;
        this.init();
    }
    init() {
        if (!this.isWords && !this.isLetters) {
            this.tag = this.tag + "<span class='line-content'>";
        }
        this._words = this.keepHtml ?
            this._splitHtmlWords(this._content) :
            this._splitWords(this._text);
        this._setContent();
        if (this.wordsJustify) this._setTramsformWords()
        setTimeout(() => {
            this.block.addClass("is-load");
        }, 300);

        this._setEvents();
    }
    _setEvents() {
        let timeoutID = null
        $(window).on("resize", () => {
            if (typeof timeoutID === "number") {
                clearTimeout(timeoutID)
            }
            timeoutID = setTimeout(() => {
                this.block.html(this._content);
                this._setContent();
                if (this.wordsJustify) this._setTramsformWords()
            }, 500)
        });

    }
    _setContent() {
        let newHtml;
        let maxHeight;
        let tempLine;
        let width;
        newHtml = this._createTemp(this.block);
        this.block.append(newHtml);
        newHtml.text("42");
        maxHeight = newHtml.height() + 2;
        newHtml.empty();

        tempLine = this._createTemp(newHtml);
        width = this.width;
        if (this.width === "auto") {
            width = this.block[0].offsetWidth;
        }

        tempLine.width(width);
        this.block.append(tempLine);
        let prev;
        let lineCount = 0;
        for (let w = 0; w < this._words.length; w++) {
            let html = tempLine.html();
            let word = this._checkSplitWorks(this._words[w], w);

            tempLine.html(html + word + " ");
            if (tempLine.html() == prev) {
                // repeating word, it will never fit so just use it instead of failing
                prev = "";
                newHtml.append(this._markupContent(this.tag, tempLine.html(), lineCount));
                tempLine.html("");
                continue;
            }
            if (tempLine.height() > maxHeight) {
                prev = tempLine.html();
                tempLine.html(html);
                newHtml.append(this._markupContent(this.tag, tempLine.html(), lineCount));
                tempLine.html("");
                w--;
                lineCount++;
            }
        }
        newHtml.append(this._markupContent(this.tag, tempLine.html(), lineCount));
        this.block.html(newHtml.html());
    }
    _checkSplitWorks(word, i) {
        if (this.isWords) {
            return `<span class="word" style="--word-index: ${i}">
            ${word}
        </span>`;
        } else {
            return word;
        }


    }
    _markupContent(tag, html, index) {
        // wrap in a temp div so .html() gives us the tags we specify
        tag = "<div class='stop'>" + tag;
        // find the deepest child, add html, then find the parent
        let $outer = $(tag)
            .find("*:not(:has('*'))")
            .html(html)
            .closest(".stop")
            .slice(-1);

        // jQuery does not support setting CSS vars until 3.2, so manually set them
        $outer.children().each(function (i, element) {
            element.style.setProperty("--line-index", index);
        });

        return $outer.html();
    }
    _splitWords(text) {
        const arrWorks = text.split(/\s+/);
        return this.isLetters ? this._splitLetters(arrWorks) : arrWorks;
    }
    _splitLetters(arrWorks) {
        return arrWorks.map(el => {
            return !el.length ?
                el :
                el.split("")
                    .map(l => {
                        let letter = `<span class="letter" style="--letter-index: ${this._lettersCount}">${l}</span>`;
                        this._lettersCount++;
                        return letter;
                    })
                    .join("");
        });

    }
    _splitHtmlWords(contents) {
        var words = [];
        var splitContent;
        for (var c = 0; c < contents.length; c++) {
            if (contents[c].nodeName === "BR") {
                words.push("<br>");
                continue;
            }
            if (contents[c].nodeType == 3) {
                splitContent = this._splitWords(contents[c].textContent || contents[c].toString());
            } else {
                var tag = $(contents[c]).clone();
                splitContent = this._splitHtmlWords(tag.contents());
                for (var t = 0; t < splitContent.length; t++) {
                    tag.empty();
                    splitContent[t] = tag.html(splitContent[t]).wrap("<p></p>").parent().html();
                }
            }
            for (var w = 0; w < splitContent.length; w++) {
                if (splitContent[w] === "") {
                    continue;
                }
                words.push(splitContent[w]);
            }
        }
        return words;
    };
    _createTemp(element) {
        return element.clone().css({ position: "absolute" });
    };
    _setTramsformWords() {
        const words = this.block.children().find(".word");
        const old_pos = []
        words.each(function (i, el) {
            old_pos.push($(el).offset().left)
        })
        this.block.addClass("is-justify")
        words.each(function (i, el) {
            const new_pos = $(el).offset().left;
            let k = new_pos - old_pos[i];
            let style = $(el).attr('style')
            $(el).attr('style', `${style}; --word-transform: ${k}px`)
            $(el).wrapInner("<span class='word-holder'>")
        })
        this.block.removeClass("is-justify")

    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/textAnimation.js